import * as React from 'react';

import { Source, Layer } from 'react-mapbox-gl';
import paintProps from '../../utils/paintProps';

import GeoCoordinates from '../../interfaces/GeoCoordinates';

interface Props {
  geoCoordinates: GeoCoordinates;
  opacity: string;
  fillColor: string;
}

const DrawnMap = ({ geoCoordinates, opacity, fillColor }: Props) => (
  <React.Fragment>
    <Source
      id='l_id'
      geoJsonSource={geoCoordinates} />
    <Layer
      paint={paintProps(opacity, fillColor)}
      type='fill'
      id='l_ids'
      sourceId='l_id' />
  </React.Fragment>
);

export default React.memo(DrawnMap);
